"use strict";
var wall = document.querySelector(".wall");
var spider = document.querySelector(".spider");
document.addEventListener("click", function(e) {
    if (!e.target.closest(".wall")) return;
    // get height and width spidder
    var spiderWidth = spider.clientWidth;
    var spiderHeight = spider.clientHeight;
    // get rect wall
    var wallRect = wall.getBoundingClientRect();
    // get position wall without border
    var positionWallX = wallRect.x + wall.clientLeft;
    var positionWallY = wallRect.y + wall.clientTop;
    // calculite target for center spider
    var targetX = e.clientX - positionWallX - spiderWidth / 2;
    var targetY = e.clientY - positionWallY - spiderHeight / 2;
    // min max
    var maxX = wall.clientWidth - spider.clientWidth;
    var maxY = wall.clientHeight - spider.clientHeight;
    targetX = Math.min(targetX, maxX);
    targetY = Math.min(targetY, maxY);
    targetX = Math.max(targetX, 0);
    targetY = Math.max(targetY, 0);
    // set spider position
    spider.style.left = targetX + "px";
    spider.style.top = targetY + "px";
});

//# sourceMappingURL=index.047de54e.js.map
